export const AppConfig = {
  realData: true,
  isDev: false
};
